<template>
  <div class="base">
    <slot />
  </div>
</template>

<style lang="scss">
.base {
  @apply pt-[var(--safe-top)];

  &::before{
    @apply block w-full h-[var(--safe-top)] bg-[var(--theme-primary-dark)] fixed top-0 content-[''] z-[99];
  }
}
</style>
